// FIXME: delete mock file

import { Automation, Notification } from '@/api/types/crm.types'

export const notificationsMock: Notification[] = [
  {
    id: 1,
    name: 'Напоминание о встрече',
    title: 'Напоминание о вашей встрече',
    content: 'У вас запланирована встреча с клиентом',
    trigger_id: 1,
    trigger: {
      id: 1,
      name: 'Статус изменен',
      type: 'status_change',
      status_id: 1,
      time_value: null,
      time_unit: null,
      field_id: null,
    },
    is_sms_enabled: true,
    is_email_enabled: true,
    is_whats_app_enabled: false,
    created_at: '2021-09-01T12:00:00Z',
    updated_at: '2021-09-01T12:00:00Z',
    sorting: 1,
  },
  {
    id: 2,
    name: 'Поздравление с днем рождения',
    title: 'Поздравление вас',
    content: 'Поздравляем вас с днем рождения',
    trigger_id: null,
    trigger: null,
    is_sms_enabled: true,
    is_email_enabled: true,
    is_whats_app_enabled: false,
    created_at: '2021-09-01T12:00:00Z',
    updated_at: null,
    sorting: 2,
  },
  {
    id: 3,
    name: 'Напоминание об оплате',
    title: 'Не забудьте оплатить',
    content: 'Срок оплаты вашего счета истекает через 3 дня',
    trigger_id: 2,
    trigger: {
      id: 2,
      name: 'Время до события',
      type: 'time_before_event',
      status_id: null,
      time_value: 72,
      time_unit: 'hours',
      field_id: null,
    },
    is_sms_enabled: false,
    is_email_enabled: true,
    is_whats_app_enabled: true,
    created_at: '2021-09-02T08:00:00Z',
    updated_at: '2021-09-02T08:00:00Z',
    sorting: 3,
  },
  {
    id: 4,
    name: 'Уведомление о новом статусе',
    title: 'Ваш статус изменен',
    content: 'Ваш статус был изменен на "Дозвонились"',
    trigger_id: 3,
    trigger: {
      id: 3,
      name: 'Статус изменен',
      type: 'status_change',
      status_id: 3,
      time_value: null,
      time_unit: null,
      field_id: null,
    },
    is_sms_enabled: true,
    is_email_enabled: false,
    is_whats_app_enabled: true,
    created_at: '2021-09-03T10:00:00Z',
    updated_at: null,
    sorting: 4,
  },
  {
    id: 5,
    name: 'Напоминание о заполнении анкеты',
    title: 'Заполните анкету',
    content:
      'Пожалуйста, заполните анкету для завершения регистрации. Текст уведомления, текст уведомления,  текст уведомления, текст уведомления, текст уведомления, текст уведомления, текст уведомления, текст уведомления, текст уведомления, текст уведомления.',
    trigger_id: null,
    trigger: null,
    is_sms_enabled: false,
    is_email_enabled: true,
    is_whats_app_enabled: false,
    created_at: '2021-09-04T09:00:00Z',
    updated_at: null,
    sorting: 5,
  },
  {
    id: 6,
    name: 'Уведомление о завершении сделки',
    title: 'Сделка завершена',
    content: 'Поздравляем! Ваша сделка успешно завершена',
    trigger_id: null,
    trigger: null,
    is_sms_enabled: true,
    is_email_enabled: true,
    is_whats_app_enabled: true,
    created_at: '2021-09-05T15:00:00Z',
    updated_at: '2021-09-05T15:00:00Z',
    sorting: 6,
  },
]

export const automationMock: Automation[] = [
  {
    id: 1,
    name: 'Добавление комментария',
    trigger_field_id: 1,
    trigger_field_value: 'LEAD',
    action_field_id: 1,
    action_type: 'add_text',
    action_value: 'Комментарий',
    created_at: '2021-09-01T12:00:00Z',
    sorting: 1,
    is_active: true,
  },
  {
    id: 2,
    name: 'Изменение статуса',
    trigger_field_id: 2,
    trigger_field_value: 'LEAD',
    action_field_id: 2,
    action_type: 'update_field',
    action_value: 'REJECTION',
    created_at: '2021-09-02T12:00:00Z',
    sorting: 2,
    is_active: true,
  },
  {
    id: 3,
    name: 'Добавление комментария',
    trigger_field_id: 3,
    trigger_field_value: 'REJECTION',
    action_field_id: 3,
    action_type: 'add_text',
    action_value: 'Комментарий',
    created_at: '2021-09-03T12:00:00Z',
    sorting: 3,
    is_active: true,
  },
  {
    id: 4,
    name: 'Изменение статуса',
    trigger_field_id: 4,
    trigger_field_value: 'REJECTION',
    action_field_id: 4,
    action_type: 'update_field',
    action_value: 'LEAD',
    created_at: '2021-09-04T12:00:00Z',
    sorting: 4,
    is_active: true,
  },
  {
    id: 5,
    name: 'Добавление комментария',
    trigger_field_id: 5,
    trigger_field_value: 'CALL+',
    action_field_id: 5,
    action_type: 'add_text',
    action_value: 'Комментарий',
    created_at: '2021-09-05T12:00:00Z',
    sorting: 57,
    is_active: true,
  },
  {
    id: 6,
    name: 'Изменение статуса',
    trigger_field_id: 6,
    trigger_field_value: 'CALL+',
    action_field_id: 6,
    action_type: 'update_field',
    action_value: 'CALL-',
    created_at: '2021-09-06T12:00:00Z',
    sorting: 5,
    is_active: true,
  },
]
